export const businessAreas = [
  {
    id: "compression",
    icon: "ri-stack-line",
    title: "압축성형 고무제품",
    subtitle: "Compression Molding",
    desc: "50년간 축적된 압축성형 기술을 바탕으로 고객이 요구하는 다양한 형상과 재질의 고무제품을 정밀하게 제조합니다. 소량에서 대량까지 유연한 생산이 가능하며, 복잡한 형상의 제품도 고품질로 구현합니다.",
    features: [
      "50톤~500톤 프레스 24기 보유",
      "제품 중량 1g ~ 5kg 대응",
      "소량(시제품 1개) ~ 대량(월 100만개) 생산 가능",
      "EPDM, NBR, CR, SBR, FKM, 실리콘 등 전 소재 대응",
    ],
    applications: ["자동차 부싱/마운트", "산업용 씰/패킹", "건설용 방진패드", "조선용 가스켓"],
    image:
      "https://storage.readdy-site.link/project_files/e8666665-2242-48cf-9593-4ebcd3ad786e/6b7d0760-d612-4a01-a535-b3c05aa1b7f8_compressed_-.webp",
  },
  {
    id: "industrial",
    icon: "ri-settings-3-line",
    title: "산업용 고무부품",
    subtitle: "Industrial Rubber Parts",
    desc: "중공업, 화학플랜트, 조선, 건설장비 등 극한 환경에서 견디는 고성능 고무부품을 제조합니다. 내열, 내화학, 내마모, 내후성 등 각 산업 환경에 최적화된 고무 컴파운드를 선정하여 제품을 설계합니다.",
    features: [
      "고온·고압·화학 환경 대응 소재 설계",
      "열교환기 가스켓, 플랜지 패킹, 다이아프램 전문",
      "대형 제품(최대 2m) 생산 가능",
      "KS, ASTM, JIS 등 국내외 규격 대응",
    ],
    applications: ["화학플랜트 씰/가스켓", "발전설비 패킹", "조선용 방충재", "건설중장비 부품"],
    image:
      "https://readdy.ai/api/search-image?query=Various%20black%20industrial%20rubber%20parts%20and%20seals%20arranged%20neatly%20on%20clean%20workshop%20table%2C%20gaskets%20O-rings%20diaphragms%20of%20different%20sizes%2C%20professional%20industrial%20components%20photography%2C%20soft%20diffused%20lighting%2C%20precision%20engineering%20aesthetic%2C%20clean%20organized%20manufacturing%20environment&width=1200&height=800&seq=krubber-business-industrial&orientation=landscape",
  },
  {
    id: "automotive",
    icon: "ri-car-line",
    title: "자동차용 고무부품",
    subtitle: "Automotive Rubber Parts",
    desc: "IATF 16949 인증을 기반으로 자동차 산업에서 요구하는 최고 수준의 품질 기준을 충족하는 고무부품을 공급합니다. 현대자동차, 기아 1차 협력사로서 엄격한 품질 관리 체계를 운영합니다.",
    features: [
      "IATF 16949 인증 품질 시스템",
      "PPAP, APQP 등 자동차 표준 프로세스 적용",
    ],
    applications: ["댐퍼", "호스/튜브", "웨더스트립"],
    image:
      "https://readdy.ai/api/search-image?query=Automotive%20rubber%20bushings%20and%20engine%20mounts%20displayed%20on%20clean%20industrial%20workbench%2C%20precision%20automotive%20components%2C%20professional%20industrial%20photography%2C%20soft%20studio%20lighting%2C%20black%20rubber%20parts%20with%20metal%20inserts%2C%20engineering%20quality%20control%20aesthetic&width=1200&height=800&seq=krubber-business-automotive&orientation=landscape",
  },
  {
    id: "electronics",
    icon: "ri-cpu-line",
    title: "전기전자용 고무부품",
    subtitle: "Electronics Rubber Parts",
    desc: "전기·전자 기기의 방수, 방진, 절연, 실링을 위한 정밀 고무부품을 제조합니다. 실리콘고무를 중심으로 전기적 특성과 내열성을 동시에 만족하는 고신뢰성 부품을 공급합니다.",
    features: [
      "절연·도전성 실리콘 고무 대응",
      "방수 등급 IP67·IP68 대응 설계",
      "초정밀 성형 (±0.05mm 공차)",
      "RoHS, REACH 등 환경규제 준수",
    ],
    applications: ["방수 씰/가스켓", "키패드/버튼", "절연 부품", "열전도 패드"],
    image:
      "https://readdy.ai/api/search-image?query=Silicone%20rubber%20electronic%20components%20and%20seals%20on%20clean%20white%20workstation%2C%20precision%20electronic%20rubber%20parts%2C%20waterproof%20gaskets%20and%20keypads%2C%20professional%20industrial%20photography%2C%20clean%20bright%20studio%20lighting%2C%20high-tech%20manufacturing%20aesthetic&width=1200&height=800&seq=krubber-business-electronics&orientation=landscape",
  },
  {
    id: "custom",
    icon: "ri-pencil-ruler-2-line",
    title: "고객 맞춤형 고무제품 개발",
    subtitle: "Custom Development",
    desc: "고객의 도면 또는 아이디어만으로도 제품 개발이 가능합니다. 소재 선정부터 금형 설계, 시제품 제작, 양산 검증까지 전 과정을 원스톱으로 지원하는 맞춤형 개발 서비스를 제공합니다.",
    features: [
      "도면 검토 및 소재 추천 컨설팅",
      "3D 모델링 및 금형 설계 협업",
      "시제품 제작 (2주 이내)",
      "양산 이행 및 사후 기술지원",
    ],
    applications: ["신규 개발품", "국산화 대체품", "성능 개선품", "역설계 제품"],
    image:
      "https://public.readdy.ai/ai/img_res/edited_742b5db300eb71115bde66dce4f391ec_24dd1d57.jpg",
  },
  {
    id: "process",
    icon: "ri-flow-chart",
    title: "제품 개발 프로세스",
    subtitle: "Development Process",
    desc: "당사의 체계적인 제품 개발 프로세스는 고객과의 긴밀한 협업을 통해 진행됩니다. 각 단계별 검증을 거쳐 최적의 품질과 납기를 보장합니다.",
    features: [
      "1단계: 요구사항 분석 및 소재 선정",
      "2단계: 금형 설계 및 제작",
      "3단계: 시제품 성형 및 치수 검증",
      "4단계: 물성 시험 및 고객 승인",
      "5단계: 양산 이행 및 품질 관리",
    ],
    applications: ["평균 개발 기간: 4~8주", "긴급 건: 2주 대응 가능", "양산 리드타임: 2~4주"],
    image:
      "https://readdy.ai/api/search-image?query=Modern%20industrial%20product%20development%20process%20flowchart%20visualization%20on%20clean%20workspace%20with%20rubber%20product%20samples%2C%20engineering%20planning%20and%20quality%20control%20concept%2C%20professional%20industrial%20photography%2C%20soft%20natural%20lighting%2C%20organized%20systematic%20approach%20aesthetic&width=1200&height=800&seq=krubber-business-process&orientation=landscape",
  },
];